<template>
  <div class="home">
    <hero
      question="Magst du"
      question1="Maiglöckchen"
      question2="Wildblumen"
      question3="Überraschungen"
      claim="Prima! Dann verschenke doch eine ganze Wilde Pracht – zum Geldgeschenk dazu."
      solution="Maiglöckchen, die typischerweise zur Konfirmation verschenkt werden, sichern auf dem Feld den Fortbestand von Bienen und Insekten. Mit einer Blühpatenschaft lässt du sie an ihrem Platz und hast gleichzeitig ein tolle und kreative Ergänzung zum Geldgeschenk."
    />
    <textblock
      headline="Blumen zur Konfirmation verschenken"
      column1="Maiglöckchen wachsen im Frühjahr und blühen im Mai und Juni – zur besten Konfirmationszeit also. Im Sommer zieren dann leuchtend rote Beeren die Pflanzen. Amseln und Rotdrosseln sorgen dafür, dass die darin enthaltenen Samen verbreitet werden. Sie sind außerdem eine wichtige Nahrungsquelle für Bienen und Insekten. Und genau deshalb stehen Maiglöckchen – aus gutem Grund – unter Naturschutz und dürfen nur in kleinen Mengen gepflückt werden. Wie viel schöner wäre es deshalb, wenn du zur Konfirmation Wildblumen verschenkst, die dort bleiben, wo sie wachsen – nämlich auf dem Feld? "
      column2="Zwar wünschen sich die meisten Konfirmanden zu ihrem besonderen Tag Geld, aber trotzdem möchtest du vielleicht nicht einfach nur einen Schein in eine Karte stecken, oder? Auch aus diesem Grund ist eine Patenschaft für ein Stück Blühwiese natürlich ideal. Die Quadratmeter wählst du dabei ganz einfach unten in unserem Formular selbst aus. Anschließend kannst du dir eine schöne Blühkarte herunterladen und bekommst sie zusätzlich von uns per Post, zum Beispiel, um sie mit kleinen Scheinen zu bestücken. Das Tolle ist: Mit der Patenschaft für eine komplette Blühsaison triffst du genau den Nerv der „Fridays-for-future-Generation“."
    />
    <cta
      title="Werde jetzt Pate für die Blühsaison 2025."
      subtitle="Und verschenke Nachhaltigkeit!"
    />
    <Orderform />
  </div>
</template>

<script type="text/babel">
// @ is an alias to /src
import Hero from "@/components/Hero.vue";
import Textblock from "@/components/Textblock.vue";
import Cta from "@/components/Cta.vue";
import Orderform from "@/components/Orderform/Orderform.vue";

export default {
  name: "Konformation",
  components: {
    Hero,
    Textblock,
    Cta,
    Orderform
  },
  metaInfo: {
    title: "Magst du Maiglöckchen?",
    meta: [
      {
        name: "description",
        content:
          "Wir auch! Typischerweise verschenkt man sie zur Konfirmation. Viel sinnvoller und nachhaltiger ist aber eine ganze Wildblumenwiese. Neugierig?"
      },
      { itemprop: "name", content: "Magst du Maiglöckchen?" },
      { property: "og:title", content: "Magst du Maiglöckchen?" },
      {
        itemprop: "description",
        content:
          "Wir auch! Typischerweise verschenkt man sie zur Konfirmation. Viel sinnvoller und nachhaltiger ist aber eine ganze Wildblumenwiese. Neugierig?"
      },
      {
        property: "og:description",
        content:
          "Wir auch! Typischerweise verschenkt man sie zur Konfirmation. Viel sinnvoller und nachhaltiger ist aber eine ganze Wildblumenwiese. Neugierig?"
      }
    ]
  }
};
</script>

<style lang="scss"></style>
